// Module
var code = "<list-item-name ng-model=\"cell\" on-download=\"$ctrl.download([$item])\" childs-loading=\"data.childsLoading || false\" childs-loaded=\"data.childsLoaded || false\" is-expanded=\"data.isExpanded || false\"></list-item-name> ";
// Exports
export default code;